import { BaseRepositoryV2 } from "@/repositories/base-repository-v2";
import type { ApiResponse } from "@/repositories/common-types";
import type {
  CancelPlanInput,
  CancelPlanPayload,
  Feature,
  GetPlanResponse,
  PlanSubscriptionMutationResponse,
} from "@/repositories/plan/types";

export default class PlanRepository extends BaseRepositoryV2 {
  path: string;
  private static instance: PlanRepository;
  constructor() {
    super();
    this.path = "/plan";
  }
  public static getInstance(): PlanRepository {
    if (!PlanRepository.instance) {
      PlanRepository.instance = new PlanRepository();
    }
    return PlanRepository.instance;
  }

  getPlan = async (): Promise<GetPlanResponse> => {
    const response = await this.get(this.path, {}, true);
    const data = await response.json();
    return data;
  };
  discountCreditsPlanByType = async (feature: Feature) => {
    const response = await this.patch(`${this.path}/${feature}`, {}, {}, true);
    return this.toAxiosResponse(response);
  };

  public async cancelPlan(
    input: CancelPlanInput = {}
  ): Promise<ApiResponse<PlanSubscriptionMutationResponse>> {
    const payload: CancelPlanPayload = {};
    if (input.reason) {
      payload.feedback = input.reason;
    }

    if (input.comment) {
      payload.comment = input.comment;
    }

    const response = await this.post(`${this.path}/cancel`, payload, {}, true);
    return this.toAxiosResponse<PlanSubscriptionMutationResponse>(response);
  }
}
